// extracted by mini-css-extract-plugin
export var divider = "anime-module--divider--ZXu1-";
export var title = "anime-module--title--N3ZKq";
export var desc = "anime-module--desc--mJJEU";
export var name = "anime-module--name--jU7N+";
export var id = "anime-module--id--nU1Sb";
export var scaleIt = "anime-module--scaleIt--zK9Fb";
export var btn = "anime-module--btn--PlBKS";
export var list = "anime-module--list--pkLdL";